export interface DownloadProjectSourceResponse {
  downloadUrl: string;
  commitSha: string;
  fileName: string;
}

/**
 * 发布状态独立于 project service barrel，避免 Store 初始化时形成循环依赖。
 */
export enum PublishStatus {
  NotPublished = 'not_published',
  Published = 'published',
  WaitUpdate = 'wait_update',
}
